import * as React from 'react'
import { View } from 'react-native'
import styled from '@theme/styled-components'

import Choice from '@components/choice/Choice'

import useI18n from '@i18n/useI18n'
import useReducer from '@store/useReducer'
import * as UserStore from '@store/user/user'
import * as IncidentStore from '@store/incident/incident'

import { FormikHelpers, useFormik } from 'formik'

interface Values {
  user: 'me' | 'other'
}

const valuesToReset: (keyof IncidentForm)[] = ['nomContact', 'prenomContact', 'emailContact', 'telephoneContact']

const User = ({ form, onForm }: IncidentFormProps) => {
  const init: Values = React.useMemo(() => ({ user: form.user }), [form.user])

  const i18n = useI18n()
  const user = useReducer(UserStore.store, (s) => s.user)

  const onSubmit = (vals: Values, { setSubmitting }: FormikHelpers<Values>) => {
    const userInfos =
      vals.user === 'me' && !!user
        ? {
            nomContact: user.nom,
            prenomContact: user.prenom,
            emailContact: user.email,
            telephoneContact: user.numeroTelephonePortable || '',
          }
        : {}

    onForm({ ...vals, ...userInfos }, true).finally(() => setSubmitting(false))
  }

  const { values, setFieldValue, handleSubmit, dirty } = useFormik<Values>({
    enableReinitialize: true,
    initialValues: init,
    onSubmit,
  })

  React.useEffect(() => {
    if (dirty) {
      // sumbit on change
      handleSubmit()
    }
  }, [values])

  if (!user) {
    // exhibitor not connected skip this form
    return null
  }

  const options = [
    { value: 'me', label: `${user.prenom} ${user.nom}` },
    { value: 'other', label: i18n.t('screens.incident.USER.other') },
  ]

  const opt = options.find((o) => o.value === values.user)

  const selectItem = (option: string) => {
    if (option !== form.user) {
      valuesToReset.forEach((value) => IncidentStore.actions.partialReset(value))
      onForm({ completed: false })
    }
    setFieldValue('user', option)
  }

  return (
    <MainContainer>
      <Choice data={options} onItemSelected={(next) => selectItem(next.value)} value={opt} />
    </MainContainer>
  )
}

export default User

const MainContainer = styled(View)`
  margin: 0 20px;
  padding-top: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 150)}px;
`
